const light = Object.freeze({
    primary: '#0067AE',
    secondary: '#0067AE',
    navBackground: '#FFFFFF',
    tileBackground: '#FFFFFF',
    appBackground: '#F5F5F5',
    inputBackground: '#FFFFFF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FB8C00',
})

const dark = Object.freeze({
    primary: '#0067AE',
    secondary: '#0067AE',
    navBackground: '#2C2C2C',
    tileBackground: '#2C2C2C',
    appBackground: '#1B1B1B',
    inputBackground: '#222222',
    logoColor: '#FFFFFF',
    logoFontColor: '#FFFFFF',
    error: '#F99C9D',
    info: '#90C9F9',
    success: '#A5D6A7',
    warning: '#FFCB7F',
})

const props = Object.freeze({
    headerLogoWidth: 90,
    headerLogoTopPadding: 10,
    headerLogoSrc: require('@/assets/custom/images/headers/living-header.png')
})

module.exports = Object.freeze({
    light,
    dark,
    props
})

